import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery } from 'gatsby';
import { useSelector, useDispatch } from 'react-redux';

import { Footer, ScrollToTop, StatusBar, TopNavigation } from './index';
import { SignupCtaSection } from '../sections';
import SubscriptionModal from './SubscriptionModal';

import { show, hide, setModalTimeout } from '../store/sub_modal';

const isBrowser = typeof window !== 'undefined';

export const subscriptionQuery = graphql`
  {
    subModal: allDatoCmsSubscriptionsModal {
      edges {
        node {
          backgroundUrl
          callToActionText
          content,
          defaultOpenDelay
          buttons {
            link
            label
          }
        }
      }
    }
    datoCmsSubscriptionPage {
        showAdsToSubscribedUsers
    }
  }
`;

const Layout = ({ children }) => {
  const user = useSelector((state) => state.user.data);
  const queryResult = useStaticQuery(subscriptionQuery);
  const data = queryResult.subModal?.edges[0]?.node;
  const showAdsToSubscribedUsers = queryResult?.datoCmsSubscriptionPage?.showAdsToSubscribedUsers;
  const showModal = useSelector(state => state.subModal.show);
  const modalTimeout = useSelector(state => state.subModal.timeout);
  const dispatch = useDispatch();
  const isSubscribed = user?.subscribed ?? false;

  const [timeoutId, setTimeoutId] = useState();

  useEffect(() => {
    if (isBrowser) {
        const openModal = localStorage.getItem('open-modal-on-load') ?? false;
        if (openModal) {
            if (!isSubscribed) dispatch(show(user));
            localStorage.removeItem('open-modal-on-load');
        }
    }
  }, []);

  useEffect(() => {
    if (timeoutId) clearTimeout(timeoutId);

    if (!modalTimeout) return;

    const newTimeoutId = setTimeout(() => {
        if (!isSubscribed) dispatch(show(user))
    }, modalTimeout * 1000);

    setTimeoutId(newTimeoutId);
  }, [modalTimeout, user]);

  useEffect(() => {
    if (!isSubscribed || showAdsToSubscribedUsers) return;

    const remove_ads = () => {
        const ads = [...document.querySelectorAll('.adsbygoogle')];
        ads.forEach(element => element.remove());
    };

    remove_ads();

    setTimeout(remove_ads, 3000);
  }, [isSubscribed])

  useEffect(() => {
    const modalDelay = data?.defaultOpenDelay || 300;
    if (!modalTimeout) dispatch(setModalTimeout(modalDelay));
  }, [data]);

  return (
    <div>
      <StatusBar />
      <TopNavigation />
      {showModal && <SubscriptionModal data={data} />}
      {children}
      <SignupCtaSection />
      <Footer />
      <ScrollToTop />
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export { Layout };
